import React from 'react';

const ModelStepViewer = ({ modelUrl, iosModelUrl }) => {
    // Check if the modelUrl is an MP4 file
    const isVideo = modelUrl && modelUrl.toLowerCase().endsWith('.mp4');

    return (
        <div>
            {isVideo ? (
                // Render a video element if the URL is an MP4 file
                <video width="320" height="240" controls>
                    <source src={modelUrl} type="video/mp4" />
                    Your browser does not support the video tag.
                </video>
            ) : (
                // Render the model-viewer for non-MP4 files
                modelUrl && (
                    <model-viewer
                        src={modelUrl}
                        alt="3D Model"
                        auto-rotate
                        autoplay
                        camera-controls
                        ar
                        ar-modes="webxr scene-viewer quick-look"
                        ios-src={iosModelUrl}
                        style={{ width: '100%', height: '400px' }}
                    />
                )
            )}
        </div>
    );
};

export default ModelStepViewer;
